import Entities from "./components/Entities";
const RouterSetting = (props) => {
    return (
        <div className="settings">
            <Entities />
        </div>
    );
};

export default RouterSetting
